module.exports = __webpack_public_path__ + "img/member_message_icon_431003.b1dcb89d.jpg";